<app-header></app-header>
<div class="resumeInfo">
  <div class="container">
    <p *ngFor="let alert of alerts">
      <ngb-alert [type]="alert.type" (close)="closeAlert(alert)">{{ alert.message }}</ngb-alert>
    </p>
    <div class="row">
      <div class="col-lg-7 col-sm-6">
        <h2>Basic Information</h2>
        <div class="form-group input-group">
          <input type="text" class="form-control form-left" name="first_name" placeholder="First Name" [(ngModel)]="resume.first_name" required>
          <input type="text" class="form-control form-right" name="last_name" placeholder="Last Name" [(ngModel)]="resume.last_name" required>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" name="address" placeholder="Address" [(ngModel)]="resume.address" required>
        </div>
        <div class="form-group input-group">
          <input type="text" class="form-control form-left" name="city" placeholder="City" [(ngModel)]="resume.city">
          <input type="text" class="form-control form-right" name="state" placeholder="State" [(ngModel)]="resume.state">
        </div>
        <div class="form-group input-group">
          <input type="email" class="form-control form-left" [disabled]="authService.session.profile.pro!=1" name="email" placeholder="Email" required [(ngModel)]="resume.email">
          <input type="text" class="form-control form-right" name="phone" placeholder="Phone" required [(ngModel)]="resume.phone">
        </div>
        <div class="resumeInfo__buttons">
          <!--<button class="btn btn-default" routerLink="/">Back</button>-->
          <button class="btn btn-primary" (click)="next()">Next</button>
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-3 col-sm-6">
        <div class="resumeInfo__bg">
          <img src="../../../../assets/images/resume_1.jpg" class="img-fluid resumeInfo__img" />
          <div class="resumeInfo__overlay"></div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</div>
<app-footer></app-footer>
